// extracted by mini-css-extract-plugin
export default {"inputSearch":"VetbotManagement_inputSearch__c4BXP","table":"VetbotManagement_table__2jl9t","approved":"VetbotManagement_approved__zvmo1","button":"VetbotManagement_button__9KTNH"};